import React from "react";
import Utils from "../../../Common/Utils";

import DashboardCard from "./DashboardCard";

function Dashboard(props) {

  React.useEffect(() => {
    Utils.SetWindowTitle("Dashboard");
  }, []);
  return (
    <>
      <div className="container-fluid ps-0">
        <h2 className="ps-4">Dashboard</h2>
        <hr />
        <div className="row ps-4">
          <DashboardCard
            title={"Taxonomy"}
            cardtext={"Taxonomy"}
            url={"/gms/taxonomy"}
          />
          <DashboardCard
            title={"Products"}
            cardtext={"Products"}
            url={"products/list"}
          />
          <DashboardCard
            title={"Rules"}
            cardtext={"Rules"}
            url={"/gms/rules/list/#"}
          />
          <DashboardCard
            title={"Smart Builder"}
            cardtext={"Smart Builder"}
            url={"/gms/smartbuilder#"}
          />
          <DashboardCard
            title={"Smart Builder v2"}
            cardtext={"Smart Builder v2"}
            url={"/gms/builder#"}
          />
          <DashboardCard title={"PDW"} cardtext={"Products"} url={"/gms/pdw"} />
        </div>
      </div>
    </>
  );
}

export default Dashboard;
